export default __webpack_public_path__ + "static/media/photo4.d03fb9e4.jpg";